import { FSP_API_ENDPOINT, WIREMOCK_HOST } from 'constants/constant-urls';
import { FSPResponse } from 'types/FSPTypes';
import handleFSPError from './handleFspError';

export class FspService {
  private mockMode: boolean;

  private host: string;

  private apiPath: string;

  private apiEndpoint: string;

  private timeout: number;

  private resolveHost(): string {
    if (this.mockMode) return WIREMOCK_HOST;
    return '';
  }

  constructor(mockMode = false) {
    this.mockMode = mockMode;
    this.host = this.resolveHost();
    this.apiPath = FSP_API_ENDPOINT;
    this.apiEndpoint = `${this.host}${this.apiPath}`;
    this.timeout = 2000;
  }

  public async getFSP(
    csrfToken: string,
    variantIds: string[],
    mockResponseValue?: string,
  ): Promise<FSPResponse | void> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), this.timeout);
    const allowedMockValues = ['fsp-api-success', 'fsp-no-stock'];

    try {
      const ids = variantIds.join(',');
      const url = `${this.apiEndpoint}?variantIds=${ids}`;

      const headers: Record<string, string> = {
        'x-csrf-token': csrfToken,
        'Content-Type': 'application/json',
        Accept: 'application/vnd.api+json',
        ...(this.mockMode && {
          'x-mock-response':
            mockResponseValue && allowedMockValues.includes(mockResponseValue)
              ? mockResponseValue
              : allowedMockValues[0],
        }),
      };

      const response = await fetch(url, {
        headers,
        method: 'GET',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      const data = (await response.json()) as FSPResponse;
      return data;
    } catch (error) {
      handleFSPError(error);
      return undefined;
    }
  }
}
export default FspService;
